import { render, staticRenderFns } from "./TenderChart.vue?vue&type=template&id=723a1bc0"
import script from "./TenderChart.vue?vue&type=script&lang=js"
export * from "./TenderChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports